"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCanRead = void 0;
var RoleTypes_1 = require("../../types/RoleTypes");
var getCustomClaimWorkspaceRole_1 = require("./getCustomClaimWorkspaceRole");
var getCanRead = function (_a) {
    var _b;
    var state = _a.state;
    var role = (0, getCustomClaimWorkspaceRole_1.getCustomClaimWorkspaceRole)({ state: state });
    return (!((_b = state.currentUser) === null || _b === void 0 ? void 0 : _b.signingOut) &&
        (role === RoleTypes_1.RoleTypes.Owner ||
            role === RoleTypes_1.RoleTypes.Writer ||
            role === RoleTypes_1.RoleTypes.Reader));
};
exports.getCanRead = getCanRead;
